export class Certificado {
  file: Blob;
  idcompania: number;
  ruc: string;
  clave: string;
  fecha: string;
}
